/** 登录url */
let apiRoot = "";
let gisServer = "";
let fileRoot = "";
let apiTest = "";
let apiJob = "";
let apiCrew = "";
let apiUrl = "";
let serveRoot = "";
let manRoot = "";
// 配置接口路径
console.log("process.env.NODE_ENV", process.env.NODE_ENV);
if (process.env.NODE_ENV === "development") {
  // 开发环境
  apiRoot = "https://test.lanshuimu.com/ism"; // 登录url 测试环境
  apiUrl = "https://test.lanshuimu.com";
  apiTest = "https://www.lanshuimu.com/test_gis/gis/webgis-v1/ship"; // 登录url 测试环境
  apiJob = "https://test.lanshuimu.com/recruit"; //职位接口
  // apiJob = "http://127.0.0.1:8081/recruit"; //职位接口
  apiCrew = "https://test.lanshuimu.com/crew_train"; //培训接口
  gisServer = "https://47.110.66.0:8080/new_gis/gis/webgis-v1/ship"; // gis测试地址
  fileRoot = "https://filetest.lanshuimu.com/file/ism/"; // 测试文件地址
  serveRoot = "https://test.lanshuimu.com/crew_platform"; //服务平台地址
  manRoot = "https://test.lanshuimu.com/ismManageServer"; //后台管理
  //   apiRoot = "https://www.lanshuimu.com/ism"; // 正式环境
  // apiUrl = "https://www.lanshuimu.com";
  // apiJob = "https://www.lanshuimu.com/crew_recruit"; //职位接口
  // apiCrew = "https://www.lanshuimu.com/crew_train"; //培训接口
  // apiTest = "https://www.lanshuimu.com/test_gis/gis/webgis-v1/ship"; // 登录url 测试环境
  // gisServer = "https://www.lanshuimu.com/test_gis/gis/webgis-v1/ship/"; // 正式
  // fileRoot = "http://filepro.lanshuimu.com/file/ism/"; // 正式文件地址
  // serveRoot = "https://www.lanshuimu.com/crew_platform"; //服务平台
} else if (process.env.NODE_ENV === "production") {
  // 正式打包
  apiRoot = "https://www.lanshuimu.com/ism"; // 正式环境
  apiUrl = "https://www.lanshuimu.com";
  apiJob = "https://www.lanshuimu.com/crew_recruit"; //职位接口
  apiCrew = "https://www.lanshuimu.com/crew_train"; //培训接口
  apiTest = "https://www.lanshuimu.com/test_gis/gis/webgis-v1/ship"; // 登录url 测试环境
  gisServer = "https://www.lanshuimu.com/test_gis/gis/webgis-v1/ship/"; // 正式
  fileRoot = "http://filepro.lanshuimu.com/file/ism/"; // 正式文件地址
  serveRoot = "https://www.lanshuimu.com/crew_platform"; //服务平台地址
  manRoot = "https://www.lanshuimu.com/ismManageServer"; //后台管理
}

export {
  apiRoot,
  fileRoot,
  gisServer,
  apiTest,
  apiJob,
  apiCrew,
  apiUrl,
  serveRoot,
  manRoot,
};
